// src/services/api.js

import axios from 'axios';

const api = axios.create({
    baseURL: 'https://api.meguide.ae/api', // Use http:// if backend is not HTTPS
  });

// Add a request interceptor to include the token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // Ensure token is stored
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
